import { gameLabel as sharedGameLabel } from '../../games';

/** Formatting + status mapping shared by the Live screens. */

export function clockOf(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function clockSecOf(ms) {
    if (!ms) return '';
    return new Date(ms).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function durationOf(ms) {
    if (!Number.isFinite(ms) || ms < 0) return '—';
    const s = Math.floor(ms / 1000);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(r).padStart(2, '0');
}

export function relOf(ms) {
    const s = Math.max(0, ms / 1000);
    const m = Math.floor(s / 60);
    const r = s - m * 60;
    return '+' + m + ':' + (r < 10 ? '0' : '') + r.toFixed(1);
}

/**
 * Session status → tile/strip presentation. egdl2 games send playing/ended (paused is defined but
 * not sent today); the relay adds active (on join) and disconnected (game socket dropped).
 */
export function sessionStateOf(status) {
    switch (status) {
        case 'paused':
            return { label: 'Paused', dot: 'var(--egdl-warning)', ink: 'var(--egdl-warning-ink)', pulse: false };
        case 'disconnected':
            return { label: 'Game disconnected', dot: 'var(--egdl-warning)', ink: 'var(--egdl-warning-ink)', pulse: true };
        case 'ended':
            return { label: 'Ended', dot: 'var(--egdl-text-secondary)', ink: 'var(--egdl-text-secondary)', pulse: false };
        case 'playing':
            return { label: 'Playing', dot: 'var(--egdl-danger)', ink: 'var(--egdl-danger)', pulse: true };
        default:
            return { label: 'Live', dot: 'var(--egdl-danger)', ink: 'var(--egdl-danger)', pulse: true };
    }
}

/** Display name for a game id, or null when the game hasn't identified itself. */
export const gameLabel = (name) => (name ? sharedGameLabel(name) : null);
